((SecondaryNav, $) => {
  'use strict';

  const addSecondaryNavItem = (name) => {
    const secondaryNav = document.querySelector(`[data-product-secondary-nav]`);
    if (!secondaryNav) return;
  
    const navLink = document.createElement(`button`);
    navLink.classList.add(`secondary-nav__link`);
    navLink.setAttribute(`data-product-secondary-nav-link`, name);
    navLink.setAttribute(`type`, `button`);
    
    const navLinkText = document.createElement(`span`);
    navLinkText.innerText = name;
    navLink.append(navLinkText);
  
    navLink.addEventListener(`click`, (event) => {
      const matchingSection = document.querySelector(`[data-product-secondary-nav-name="${ event.currentTarget.getAttribute(`data-product-secondary-nav-link`) }"]`);
      if (!matchingSection) return;
  
      window.scrollTo({ top: matchingSection.offsetTop - document.querySelector(`#shopify-section-header`).offsetHeight - secondaryNav.offsetHeight, behavior: `smooth` });
    });
  
    secondaryNav.appendChild(navLink);
  };
  
  const checkActiveSecondaryItem = () => {
    const secondaryNavItems = document.querySelectorAll(`[data-product-secondary-nav-name]`);
    if (secondaryNavItems.length <= 0) return;
    const activeBreakpoint = window.scrollY + (window.innerHeight / 3);
    const activeSecondaryItem = document.querySelector(`[data-product-secondary-nav-link].is-active`);
    const newActiveSecondaryItemArray = Array.from(secondaryNavItems).filter((navItem) => navItem.offsetTop <= activeBreakpoint);
    const newActiveSecondaryItem = newActiveSecondaryItemArray[newActiveSecondaryItemArray.length - 1];
  
    if (newActiveSecondaryItem && (!activeSecondaryItem || newActiveSecondaryItem.getAttribute(`data-product-secondary-nav-name`) !== activeSecondaryItem.getAttribute(`data-product-secondary-nav-link`))) {
      if (activeSecondaryItem) activeSecondaryItem.classList.remove(`is-active`);
      document.querySelector(`[data-product-secondary-nav-link="${newActiveSecondaryItem.getAttribute(`data-product-secondary-nav-name`)}"]`).classList.add(`is-active`);
    }
  };
  
  const initSecondaryNav = () => {
    if (!document.querySelector(`body`).classList.contains(`template-product`)) return;
  
    const secondaryNav = document.querySelector(`[data-product-secondary-nav]`);
  
    if (!secondaryNav) return;
    const secondaryNavItems = document.querySelectorAll(`[data-product-secondary-nav-name]`);
  
    if (secondaryNavItems.length <= 0) return;
  
    addSecondaryNavItem(`Details`);
    const productDetails = document.querySelector(`.wrapper--product-details`);
    productDetails.setAttribute(`data-product-secondary-nav-name`, `Details`);
  
    secondaryNavItems.forEach((navItem) => {
      const linkText = navItem.getAttribute(`data-product-secondary-nav-name`)
      addSecondaryNavItem(linkText);
    });

    document.body.classList.add(`has-secondary-nav`);
  
    checkActiveSecondaryItem();
  };

  const bindUIActions = () => {
    if (!document.body.classList.contains(`template-product`)) return;
  
    window.addEventListener(`scroll`, checkActiveSecondaryItem);
    window.addEventListener(`resize`, checkActiveSecondaryItem);
  }

  const init = () => {
    initSecondaryNav();
    bindUIActions();
  };

  SecondaryNav.init = init;
})(window.SecondaryNav = window.SecondaryNav || {}, jQuery);